/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const deleteContactPathParamsSchema = z.object({
    "contactId": z.uuid()
    })

export const deleteContactHeaderParamsSchema = z.object({
    "x-tenant-id": z.optional(z.string().describe("Required tenant context header for tenant-scoped endpoints guarded by ApiGuard."))
    }).optional()

export const deleteContact204Schema = z.any()

/**
 * @description Missing tenant context or invalid x-api-key header for guarded endpoints.
 */
export const deleteContact401Schema = z.any()

export const deleteContactMutationResponseSchema = z.lazy(() => deleteContact204Schema)